import React, { FC, useCallback } from "react";
import { IconButton } from "@evergis/ui";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { useCopyFeatureDialog, useDeleteFeatureDialog, useDialogInfo } from "../../../../hooks/useDialogs";
import { CopyIconButton, EditIconButton } from "./styled";
import { useKey } from "../../../../hooks/useKey";
import { isLocationCatalogSelector } from "../../../../ducks/location/selectors";

type DefaultControlsProps = {
  toggleEditMode?: VoidFunction;
  hasEditRights?: boolean;
  hasCopyRights?: boolean;
};

export const DefaultControls: FC<DefaultControlsProps> = ({ toggleEditMode, hasEditRights, hasCopyRights }) => {
  const openDeleteFeatureDialog = useDeleteFeatureDialog();
  const openCopyFeatureDialog = useCopyFeatureDialog();
  const isCatalogLocation = useSelector(isLocationCatalogSelector);
  const { isOpen: someDialogIsOpen } = useDialogInfo();
  const { t } = useTranslation("common");

  const handleOpenDeleteFeatureDialog = useCallback(() => {
    if (hasEditRights && !isCatalogLocation && !someDialogIsOpen) {
      openDeleteFeatureDialog();
    }
  }, [hasEditRights, isCatalogLocation, openDeleteFeatureDialog, someDialogIsOpen]);

  useKey({
    Delete: handleOpenDeleteFeatureDialog,
  });

  return (
    <>
      {hasCopyRights && (
        <CopyIconButton kind={"copy"} title={t("actions.copy")} onClick={() => openCopyFeatureDialog()} />
      )}
      {hasEditRights && (
        <>
          <CopyIconButton kind={"copy"} title={t("actions.copy")} onClick={() => openCopyFeatureDialog()} />
          <IconButton kind={"delete"} title={t("actions.delete")} onClick={handleOpenDeleteFeatureDialog} />
          <EditIconButton kind={"edit"} onClick={toggleEditMode} title={t("actions.edit")}>
            {t("actions.edit")}
          </EditIconButton>
        </>
      )}
    </>
  );
};
